// Lightweight menu catalog for the site header/footer. Kept separate from the
// full product/state data (~190 KB) so it doesn't ship on every page's first
// load. Kept in sync by src/data/nav-catalog.test.ts.
export type NavProduct = { slug: string; name: string; shortName: string; tagline: string };
export type NavState = { slug: string; name: string };
export const navProducts: NavProduct[] = [
  {
    "slug": "dscr-loans",
    "name": "DSCR Rental Property Loans",
    "shortName": "DSCR",
    "tagline": "DSCR loan: qualify with rent, not tax returns."
  },
  {
    "slug": "foreign-national-loans",
    "name": "Foreign National Loans",
    "shortName": "Foreign National",
    "tagline": "US investment property loans for non-US citizens."
  },
  {
    "slug": "construction-loans",
    "name": "Ground-Up Construction Loans",
    "shortName": "Construction",
    "tagline": "Fund the build. Take out to a DSCR loan."
  },
  {
    "slug": "fix-and-flip-loans",
    "name": "Fix & Flip Loans",
    "shortName": "Fix & Flip",
    "tagline": "Short-term acquisition + rehab capital for investors."
  },
  {
    "slug": "airbnb-short-term-rental-loans",
    "name": "Airbnb / Short-Term Rental Loans",
    "shortName": "Airbnb / STR",
    "tagline": "DSCR loans that qualify with STR revenue, not long-term rent."
  },
  {
    "slug": "section-8-loans",
    "name": "Section 8 DSCR Loans",
    "shortName": "Section 8 DSCR",
    "tagline": "DSCR loans that count your HAP contract as verified income."
  },
  {
    "slug": "bridge-loans",
    "name": "Bridge Loans",
    "shortName": "Bridge",
    "tagline": "Buy now, refinance later when the property is stabilized."
  },
  {
    "slug": "portfolio-rental-loans",
    "name": "Portfolio Rental Loans",
    "shortName": "Portfolio",
    "tagline": "Finance multiple investment properties with one loan."
  },
  {
    "slug": "multifamily-loans",
    "name": "Multifamily Loans (5+ Units)",
    "shortName": "Multifamily 5+",
    "tagline": "Commercial multifamily financing underwritten to NOI and cap rate — not your tax returns."
  },
  {
    "slug": "hard-money-loans",
    "name": "Hard Money & Private Money Loans",
    "shortName": "Hard Money",
    "tagline": "Asset-based capital that closes in days — for deals a bank or DSCR lender can't touch."
  }
];
export const navStates: NavState[] = [
  {
    "slug": "alabama",
    "name": "Alabama"
  },
  {
    "slug": "alaska",
    "name": "Alaska"
  },
  {
    "slug": "arkansas",
    "name": "Arkansas"
  },
  {
    "slug": "colorado",
    "name": "Colorado"
  },
  {
    "slug": "connecticut",
    "name": "Connecticut"
  },
  {
    "slug": "district-of-columbia",
    "name": "District of Columbia"
  },
  {
    "slug": "delaware",
    "name": "Delaware"
  },
  {
    "slug": "florida",
    "name": "Florida"
  },
  {
    "slug": "georgia",
    "name": "Georgia"
  },
  {
    "slug": "hawaii",
    "name": "Hawaii"
  },
  {
    "slug": "illinois",
    "name": "Illinois"
  },
  {
    "slug": "indiana",
    "name": "Indiana"
  },
  {
    "slug": "kansas",
    "name": "Kansas"
  },
  {
    "slug": "kentucky",
    "name": "Kentucky"
  },
  {
    "slug": "louisiana",
    "name": "Louisiana"
  },
  {
    "slug": "maine",
    "name": "Maine"
  },
  {
    "slug": "maryland",
    "name": "Maryland"
  },
  {
    "slug": "massachusetts",
    "name": "Massachusetts"
  },
  {
    "slug": "michigan",
    "name": "Michigan"
  },
  {
    "slug": "mississippi",
    "name": "Mississippi"
  },
  {
    "slug": "missouri",
    "name": "Missouri"
  },
  {
    "slug": "new-jersey",
    "name": "New Jersey"
  },
  {
    "slug": "new-hampshire",
    "name": "New Hampshire"
  },
  {
    "slug": "new-mexico",
    "name": "New Mexico"
  },
  {
    "slug": "new-york",
    "name": "New York"
  },
  {
    "slug": "ohio",
    "name": "Ohio"
  },
  {
    "slug": "oklahoma",
    "name": "Oklahoma"
  },
  {
    "slug": "pennsylvania",
    "name": "Pennsylvania"
  },
  {
    "slug": "rhode-island",
    "name": "Rhode Island"
  },
  {
    "slug": "south-carolina",
    "name": "South Carolina"
  },
  {
    "slug": "tennessee",
    "name": "Tennessee"
  },
  {
    "slug": "texas",
    "name": "Texas"
  },
  {
    "slug": "virginia",
    "name": "Virginia"
  },
  {
    "slug": "washington",
    "name": "Washington"
  },
  {
    "slug": "west-virginia",
    "name": "West Virginia"
  },
  {
    "slug": "wisconsin",
    "name": "Wisconsin"
  },
  {
    "slug": "wyoming",
    "name": "Wyoming"
  }
];
